import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import { getTheme, screen } from '../../global/utils';
import swash from '../../img/swash.svg';

const CardHeaderWrapper = styled.div`
  margin-top: -${getTheme('spacer', 'xl')};
  margin-left: -${getTheme('spacer', 'xl')};
  margin-right: -${getTheme('spacer', 'xl')};
  margin-bottom: ${getTheme('marginBottom', 'xl')};
  padding-top: ${getTheme('spacer', 'xl')};
  padding-left: ${getTheme('spacer', 'xl')};
  padding-right: ${getTheme('spacer', 'xl')};
  color: ${getTheme('textColor', 'alt')};

  @media (max-width: ${screen('smMax')}) {
    margin-top: -${getTheme('spacer', 'l')};
    margin-left: -${getTheme('spacer', 'l')};
    margin-right: -${getTheme('spacer', 'l')};
    margin-bottom: ${getTheme('marginBottom', 'l')};
    padding-top: ${getTheme('spacer', 'l')};
    padding-left: ${getTheme('spacer', 'l')};
    padding-right: ${getTheme('spacer', 'l')};
  }

  ${props =>
    props.branded &&
    css`
      background: url(${swash}) no-repeat left top;
    `};
`;

class CardHeader extends Component {
  render() {
    return (
      <CardHeaderWrapper
        className={this.props.className}
        branded={this.props.branded}
      >
        {this.props.children}
      </CardHeaderWrapper>
    );
  }
}

export default CardHeader;



// WEBPACK FOOTER //
// ./src/components/cards/CardHeader.js